import React, { useEffect, useState } from 'react'
import Scrollbars from 'react-custom-scrollbars-2'
import { Link, useLocation } from 'react-router-dom'
import { routes } from '../../utils/routes'
import { useDispatch, useSelector } from 'react-redux'
import { setHoverSidebar } from '../../store/commonSlice'
import { avatar29 } from '../../utils/images/imagepath'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faCheck } from '@fortawesome/free-solid-svg-icons'
const Sidebar = () => {
  const location = useLocation()
  const dispatch = useDispatch()
  const [activeModule, setActiveModule] = useState<string | null>('')
  const subDrop = (res: string) => {
    localStorage.setItem('menuOpened', res)
    setActiveModule((prev) => {
      return prev == res ? '' : res
    })
  }

  useEffect(
    () => setActiveModule(localStorage.getItem('menuOpened')),
    [location.pathname],
  )

  const { info, isSuperAdmin, rolesPermissions } = useSelector(
    (state: any) => state?.role,
  )
  const roles: any = info || {}
  const isSAdmin: any = isSuperAdmin || false

  const user_management = isSAdmin || roles.user_management
  const sales = isSAdmin || roles.sales
  const sales_estimate = isSAdmin || roles.sales_estimate
  const sales_order = isSAdmin || roles.sales_order
  const sales_invoice = isSAdmin || roles.sales_invoice
  const sales_payment = isSAdmin || roles.sales_payment
  const purchase = isSAdmin || roles.purchase
  const estimate = isSAdmin || roles.estimate
  const order = isSAdmin || roles.order
  const invoice = isSAdmin || roles.invoice
  const payment = isSAdmin || roles.payment
  const customers = isSAdmin || roles.customers
  const companies = isSAdmin || roles.companies
  const settings =
    isSAdmin ||
    roles?.system_definitions ||
    roles?.personal_settings ||
    roles?.sales_settings ||
    roles?.purchase_settings

  return (
    <>
      <div
        className='sidebar sideWrapper'
        id='sidebar'
        onMouseEnter={() => dispatch(setHoverSidebar(true))}
        onMouseLeave={() => dispatch(setHoverSidebar(false))}
      >
        <div className='sidebar-inner slimscroll'>
          <div id='sidebar-menu' className='sidebar-menu'>
            <ul>
              <li className='submenu-open'>
                <h6 className='submenu-hdr'>Main</h6>
                <ul>
                  <li className='submenu'>
                    <Link
                      to={routes.adminDashboard.path}
                      className={
                        location.pathname.includes('admin-dashboard')
                          ? 'active'
                          : ''
                      }
                    >
                      <i className='icon-dashboard'></i>
                      <span>Dashboard</span>
                    </Link>
                  </li>
                  <li className='submenu'>
                    <Link to='javascript:void(0);'>
                      <i className='icon-notificaiton'></i>
                      <span>Notifications</span>
                    </Link>
                  </li>
                </ul>
              </li>
              <li className='submenu-open'>
                <h6 className='submenu-hdr'>Others</h6>
                <ul>
                  <li className='submenu'>
                    <Link
                      to={routes.truckList.path}
                      className={
                        location.pathname.includes('truck-list') ? 'active' : ''
                      }
                    >
                      <i className='icon-trucks-list'></i>
                      <span>Trucks List</span>
                    </Link>
                  </li>
                  <li className='submenu'>
                    <Link
                      to={routes.checkList.path}
                      className={
                        location.pathname.includes('check-list') ? 'active' : ''
                      }
                    >
                      <i className='icon-checklist'></i>
                      <span>Check List</span>
                    </Link>
                  </li>
                  <li className='submenu'>
                    <Link
                      to={routes.driversList.path}
                      className={
                        location.pathname.includes('drivers-list')
                          ? 'active'
                          : ''
                      }
                    >
                      <i className='icon-driverslist'></i>
                      <span>Drivers List</span>
                    </Link>
                  </li>
                  <li className='submenu'>
                    <Link
                      to={routes.fleetList.path}
                      className={
                        location.pathname.includes('fleet-list') ? 'active' : ''
                      }
                    >
                      <i className='icon-driverslist'></i>
                      <span>Fleet Manager List</span>
                    </Link>
                  </li>
                  <li className='submenu'>
                    <Link to='javascript:void(0);'>
                      <i className='icon-health'></i>
                      <span>Health</span>
                    </Link>
                  </li>
                  <li className='submenu'>
                    <Link to='javascript:void(0);'>
                      <i className='icon-profile'></i>
                      <span>Profile</span>
                    </Link>
                  </li>
                  <li className='submenu'>
                    <Link to='javascript:void(0);'>
                      <i className='icon-support'></i>
                      <span>Support</span>
                    </Link>
                  </li>
                  <li className='submenu'>
                    <Link to='javascript:void(0);'>
                      <i className='icon-settings'></i>
                      <span>Settings</span>
                    </Link>
                  </li>
                </ul>
              </li>
            </ul>
            <div className='sidebar-footer'>
              <div className='sidebar-profile'>
                <Link to='login.html'>
                  <div className='sidebar-profile-img'>
                    <img src={avatar29} className='img-fluid' alt='Profile' />
                    <p>
                      <span>Holly Golightly</span>Admin
                    </p>
                  </div>
                </Link>
                <div className='sidebar-profile-logout'>
                  <Link to='login.html'>
                    <svg
                      width='21'
                      height='21'
                      viewBox='0 0 18 18'
                      fill='none'
                      xmlns='http://www.w3.org/2000/svg'
                    >
                      <path
                        d='M6.67499 5.66969C6.90749 2.96969 8.29499 1.86719 11.3325 1.86719H11.43C14.7825 1.86719 16.125 3.20969 16.125 6.56219V11.4522C16.125 14.8047 14.7825 16.1472 11.43 16.1472H11.3325C8.31749 16.1472 6.92999 15.0597 6.68249 12.4047'
                        stroke='#292D32'
                        stroke-width='1.3'
                        stroke-linecap='round'
                        stroke-linejoin='round'
                      />
                      <path
                        d='M11.25 9H2.71503'
                        stroke='#292D32'
                        stroke-width='1.3'
                        stroke-linecap='round'
                        stroke-linejoin='round'
                      />
                      <path
                        d='M4.3875 6.4873L1.875 8.9998L4.3875 11.5123'
                        stroke='#292D32'
                        stroke-width='1.3'
                        stroke-linecap='round'
                        stroke-linejoin='round'
                      />
                    </svg>
                  </Link>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  )
}

export default Sidebar
